import { ComponentVisibility } from '../types'
import { DateAndTimeUtils } from '../../../shared/utils/date-and-time-utils'
import { Page, Product } from '@spartacus/core'

export class CmsComponentUtils {

  static isComponentVisible (visibility: ComponentVisibility | undefined, isFSPreview: boolean): boolean {
    if (isFSPreview) {
      return true
    }
    return !visibility?.hide && DateAndTimeUtils.isCurrentDateBetween(visibility?.hideBefore, visibility?.hideAfter)
  }

  static comparePages (p1: Page | Product | null, p2: Page | Product | null): boolean {
    if (p1?.url) {
      return p1.url === p2?.url
    } else {
      return (p1 as Page)?.properties?.formData?.pt_seoUrl?.value === (p2 as Page)?.properties?.formData?.pt_seoUrl?.value
    }
  }
}
